import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const TypedResponse = ({ fullText, typingSpeed = 10, isTyping, onComplete }) => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    if (!isTyping || !fullText) {
      setDisplayText(fullText || '');
      if (!isTyping && onComplete) onComplete();
      return;
    }

    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setDisplayText(fullText.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(interval);
        setDisplayText(fullText);
        onComplete();
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [fullText, isTyping, typingSpeed, onComplete]);

  return (
    <ReactMarkdown
      components={{
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          return !inline && match ? (
            <SyntaxHighlighter style={dark} language={match[1]} PreTag="div" {...props}>
              {String(children).replace(/\n$/, '')}
            </SyntaxHighlighter>
          ) : (
            <code className={className || 'inline-code'} {...props}>
              {children}
            </code>
          );
        },
        ul({ children }) {
          return <ul className="markdown-list">{children}</ul>;
        },
        ol({ children }) {
          return <ol className="markdown-list">{children}</ol>;
        },
        li({ children }) {
          return <li className="markdown-list-item ">{children}</li>;
        },
        p({ children }) {
          return <p className="markdown-paragraph">{children}</p>;
        },
      }}
    >
      {displayText}
    </ReactMarkdown>
  );
};

export default TypedResponse;